import BulkChangeLeadLabelModal from './BulkChangeLeadLabelModal';

export default BulkChangeLeadLabelModal;
